<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container banner">
      <div class="banner-box">
        <div class="title">
          <span>{{ $t('homepage.text1') }}</span>
        </div>
        <div class="des">{{ $t('homepage.text2') }}</div>
        <el-button
          class="el-button--special4 block icon-nft"
          style="margin-bottom: 0.2rem"
          @click="handleRoute('/user/mint')"
          >{{ $t('homepage.text4') }}</el-button
        >
        <el-button
          class="el-button--special block icon-right"
          @click="handleRoute('/user/actcategory')"
          >{{ $t('homepage.text3') }}</el-button
        >
        <div class="sss" @click="handleRoute('/user/howtoplay')">
          {{ $t('add.text60') }}
        </div>
        <div class="title2 special">
          <span>{{ $t('homepage.text5') }}</span>
        </div>
        <div class="switch-tab" v-if="list.length > 0">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            :class="item.active ? 'active' : ''"
            @click="handleSwitch(item)">
            {{ item.label }}
          </div>
        </div>
        <div class="switch-content">
          <div
            class="des"
            v-html="list[currentIndex] && list[currentIndex].value"></div>
        </div>
        <el-button
          class="default block"
          style="margin-top: 0.2rem"
          @click="handleMore"
          >{{ $t('homepage.text6') }}</el-button
        >
      </div>
      <Resource />
    </div>
  </div>
</template>
<script>
import Resource from '@/components/Resource'

export default {
  name: 'UserIndex',
  components: {
    Resource
  },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      list: [],
      currentIndex: 0
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.list = [
        {
          label: this.$t('discord'),
          value: this.$t('homepage.text7'),
          active: true
        },
        {
          label: this.$t('award'),
          value: this.$t('homepage.text8')
        },
        {
          label: this.$t('nft'),
          value: this.$t('homepage.text9')
        }
      ]
    },
    handleRoute(path, tabIndex) {
      if (tabIndex) {
        this.$router.push({ path: path, query: { tabIndex: tabIndex } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleSwitch(e) {
      this.list = this.list.map((item, index) => {
        if (item.label === e.label) {
          item.active = true
          this.currentIndex = index
        } else {
          item.active = false
        }
        return item
      })
    },
    handleMore() {
      if (this.currentIndex === 0) {
        this.handleRoute('/user/nftlist', '1')
      } else if (this.currentIndex === 1) {
        this.handleRoute('/user/actcategory')
      } else if (this.currentIndex === 2) {
        this.handleRoute('/user/nftlist', '2')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/index.vue